module.exports = __webpack_public_path__ + "static/media/visa.32d52906.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/card-types/visa.png
// module id = 567
// module chunks = 0